<div
  class="filters-container w-100"
  [ngClass]="{ light: isLight, dark: !isLight, 'machine-performance-filters': true }"
>
  <div class="d-flex align-items-center gap-2 flex-column flex-xl-row w-100 w-xl-auto">
    @if (hasKeywordFilter && useInlineKeywordFilter) {
      <div class="form-group w-100 rounded-0 fw-bold">
        <input
          type="text"
          class="form-control filter-control keyword-input"
          [placeholder]="keywordFilterPlaceholder | translate"
          [formControl]="keywordSearchControl"
          [ngClass]="{ light: isLight, dark: !isLight }"
        />
      </div>
    }

    @for (field of fields; track field.key; let i = $index) {
      @if (field.key !== 'keyword' && field.key !== 'custom_period' && field.key !== 'date') {
        <app-icam-select
          ngClass="w-100 w-xl-auto"
          [field]="field"
          selectType="filter"
          (selectedFilter)="filterSelected($event)"
          [translateOptions]="translateOptions"
          [type]="tableType"
        />
      }
      @if (field.key !== 'keyword' && field.key === 'custom_period') {
        <div class="date-range-separator"></div>
      }
      @if (field.key === 'custom_period' || field.key === 'date') {
        <app-icam-datepicker
          ngClass="w-100 w-xl-auto"
          [name]="field.key === 'custom_period' ? 'custom_period' : 'date'"
          [isLight]="isLight"
          [initialValue]="field.initialValue"
          (dateChange)="onDatepickerChange($event)"
        />
      }
    }

    @if (canOrder && sortingOptions) {
      <div class="pl-3 d-flex flex-column flex-xl-row align-items-center gap-1 gap-xl-2 w-100 w-xl-auto mt-1 mt-xl-0">
        <div class="d-flex gap-1 align-items-center align-self-start align-self-xl-center">
          <app-icam-icon iconName="sort" [iconHeight]="'14px'" />
          <p class="m-0 p-0 text-uppercase text-nowrap filter text-left">
            {{ 'FILTER.ORDER_BY' | translate }}
          </p>
        </div>
        @for (field of sortingOptions; track field.key) {
          <app-icam-select
            ngClass="w-100 w-xl-auto order-by "
            [field]="field"
            selectType="sort"
            [translateOptions]="translateOptions"
            [type]="tableType"
            (selectedFilter)="filterSelected($event)"
          />
        }
      </div>
    }
    @if (selectedValue) {
      <div class="d-flex justify-content-end">
        <button class="underlined-text" (click)="onResetFilters()">RESET</button>
      </div>
    }
  </div>
</div>
